import { z } from 'zod';
// import { healthcardSchema } from './healthcard';

import { basePatientSchema } from './basePatient';
import { claimSchema } from './claim';
import { claimHistoriesSchema } from './claimHistory';

export const claimEditPatientSchema = basePatientSchema.extend({
  claims: z
    .lazy(() => claimSchema.array())
    .optional()
    .nullable(),
  claimHistories: z
    .lazy(() => claimHistoriesSchema.array())
    .optional()
    .nullable(),
});
